import {
  BiBookOpen,
  BiCodeBlock,
  BiData,
  BiSolidFlask,
  BiTrophy,
  BiVideo,
} from 'react-icons/bi'
import type { NavItem } from '../types'

export const resources: NavItem = {
  name: 'Resources',
  linkSections: [
    {
      columns: 2,
      sections: [
        {
          header: 'Quantum Computing Resources',
          items: [
            {
              name: 'Codebook',
              href: '/codebook',
              icon: BiBookOpen,
              description: 'Learn quantum computing with PennyLane.',
            },
            {
              name: 'Coding challenges',
              href: '/challenges',
              icon: BiTrophy,
              description:
                'Test your skills with quantum coding challenges and earn badges.',
            },
            {
              name: 'Videos',
              href: '/videos',
              icon: BiVideo,
              description:
                'Sit back and explore our curated selection of expert videos.',
            },
            {
              name: 'Demos library',
              href: '/demonstrations',
              icon: BiSolidFlask,
              description:
                'Explore the quantum landscape with our research-level demos written by experts.',
            },
            {
              name: 'Compilation hub',
              href: '/compilation',
              icon: BiCodeBlock,
              description:
                'Find explanations and implementations of important quantum compilation techniques.',
            },
            {
              name: 'Quantum datasets',
              href: '/datasets',
              icon: BiData,
              description:
                'Speed up research with quantum datasets tailored for use with PennyLane.',
            },
          ],
          cta: { text: 'Browse all', href: '/search' },
        },
      ],
    },
  ],
  cardSections: [
    {
      header: 'Latest Quantum Computing Demos',
      type: 'content',
      cta: {
        text: 'Explore demos library',
        href: '/demonstrations',
      },
      cards: {
        limit: 2,
        filters: {
          contentType: 'DEMO',
          sort: 'publication_date',
          categories: ['quantum computing'],
        },
        fallbackImageSrc:
          'https://assets.cloud.pennylane.ai/navbar/pennylane-generic-demo-thumbnail.png',
      },
    },
  ],
}
